// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as TdsRepoManager from "../domain/repo/TdsRepoManager.bs.js";
import * as TdsAssetManager from "../assets/TdsAssetManager.bs.js";
import * as TdsFormComponent from "./TdsFormComponent.bs.js";
import * as LoaderComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/custom/loader/LoaderComponent.bs.js";

TdsAssetManager.importCss(undefined);

var TdsFormLoaderConfig = {};

var TdsFormLoaderComponent = LoaderComponent$Catalyst.LoaderComponent(TdsFormLoaderConfig);

function TdsFormWrapper(Props) {
  var uuid = Props.uuid;
  return React.createElement(TdsFormLoaderComponent.make, {
              fetchData: (function (param) {
                  var RepoInstance = TdsRepoManager.getTdsRepo(undefined);
                  return Curry._1(RepoInstance.fetchTdsFormData, uuid);
                }),
              renderView: (function (tdsFormData, refreshView) {
                  return React.createElement("div", undefined, React.createElement(TdsFormComponent.make, {
                                  uuid: uuid,
                                  tdsFormData: tdsFormData,
                                  refreshView: refreshView
                                }));
                })
            });
}

var make = TdsFormWrapper;

var $$default = TdsFormWrapper;

export {
  TdsFormLoaderConfig ,
  TdsFormLoaderComponent ,
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
